var s = window.s || {};

s.scrollSelector = null;
s.basePath = '/media/default/';
s.emptyGif = '/media/default/images/0.gif';
s.videoPlayer = {
		width: 430,
		height: 278,
		version: "9.0.0"
	};
s.paths = {
	expressInstall: 'swf/expressInstall.swf',
	videoPlayer: 'swf/videoplayer.swf',
	ajaxLoader: 'images/ajax-loader.gif',

	photoGalleryPopup: 'popups/photoGallery.html',
	videoPopup: 'popups/video.html',
};
s.tpls = {
	ajaxLoader: '<div class="loader" style="display:none;"><img src="{src}" alt="Загружается..."></div>',
	popupHolder: '<div class="popup-bg-layer" style="left:-9999px;"><div class="bg">&nbsp;</div></div>',
	popupHandHolder: '<div class="popup-bg-layer hand-popup-bg-layer" style="left:-9999px;"><div class="bg">&nbsp;</div></div>',
	errorPopup: '<div class="popup"><a href="#" class="close js-close-popup">close</a><div class="center"><h2>&nbsp;</h2><div class="popup-content">&nbsp;</div></div></div>',
	commonFormError: '<div class="big-note common-error-msg"><div class="note-holder"></div></div>',
	fakeMainContent: '<div class="white-box"><div class="white-holder"><div class="white-frame" style="height:600px;"></div></div></div>'
};
s.mainOptions = {
	wrapperSelector : '#wrapper',
	mainSelector : '#wrapper .js-ajax-wrapper',
	headerSelector : '#wrapper .header-holder',
//	footerSelector : '',
//	scrollSelector : '',
};
s.ajaxOptions = {
	container : '#wrapper',
	elemToSet : '.js-ajax-wrapper',
	subSelector : '.js-ajax-sub-holder',
};
s.popupOptions = {
//	holder : '.popup-holder',
};
s.popupScripts = function($popup){
	this.initPageCaptcha($popup);
	this.initPageAjaxForm($popup);
	this.initInputs($popup);
	this.initFileInput($popup);
};



/* Ajax handlers */
	s.classAjaxPagerHandler = function(){
		var obj = new s.classAjaxDefaultHandler();
		obj.requestParams = {"__pager__":1};
		obj.canGetPage=function(url, options){
			var link = $(obj.elemToSet).find('.js-pager').attr("data-url");
			if ( ! link) return false;
			link = link.replace(/[&?]page=.*/, '');
			return (url.indexOf(link) > -1);
		};
		return obj;
	};


	s.initPagePortfolioPopup = function()
	{
		s.dom.main.on('click', 'a.js-portfolio-page-popup', function(e){
			e.preventDefault();
			e.stopPropagation();

			var el = $(e.currentTarget);
			s.loadPopup(el.attr("data-popup-name"), el.attr("data-popup-url"), s.showPortfolioPopup, [el]);

			return false;
		});
	};

	s.showPortfolioPopup = function($popup, a)
	{
		if (s.mainAjaxLoader.pageLoaded === false) return;

		s.showAjaxLoader();
		s.mainAjaxLoader.pageLoaded = false;

		var loc = s.getLocation(),
			href = a.attr('href').replace(loc.protocol+'//'+loc.host, '');

		var request = $.ajax({
			url: href,
			data: {"__ajax__":"1", "__popup__":"1"},
			type: "GET",
			async:true,
			cache:true,
			dataType: "html"
		});
		request.done(function(msg) {
			var handler = s.mainAjaxLoader.getHandler(),
				prepared_data = handler.prepareInsert(msg);

			$popup.find('.popup-content').empty()
				.append(prepared_data);

			s.mainAjaxLoader.pageLoaded = '';

			s.openPopup($popup);
		});
		request.fail(function(jqXHR, textStatus, errorThrown) {
			if (textStatus !== "abort" && jqXHR.readyState > 0)
			{
				var message = "Не удалось выполнить запрос",
					title = "Ошибка";

				if (jqXHR.status == 404)
				{
					message = "<b>Запрашиваемая страница не найдена</b>";
					title = "404 ошибка";
				}

				if (textStatus === "error")
				{
					message += "<br>[ <b>" + jqXHR.status + "</b> ]  " + errorThrown;
				}
				s.showErrorAlert(message, title);
			}
			s.mainAjaxLoader.pageLoaded = '';
		});
		request.always(function(){
			s.hideAjaxLoader();
			if ( ! s.mainAjaxLoader.pageLoaded) {
				s.mainAjaxLoader.pageLoaded='';
			}
		});

		console.log(s.mainAjaxLoader.requestMsg);
	}



	s.ajaxHandlers = {
		"pager" : new s.classAjaxPagerHandler(),
	};

/* Captcha */
	s.getCaptchaUrl = function(){
		return '/captcha/default?_rnd='+((new Date()).getTime());
	};

/* Menu */
	s.setMenu = function(url){
		$('ul#nav > li.active').removeClass('active');

		$('ul#nav > li > a', this.dom.header).each(function(i, e){
			var _menu_link = $(e).attr('href');
			if (url.indexOf(_menu_link) != -1)
			{
				$(e).closest('li')
					.addClass('active');
				return;
			}
		});
	};

/* Counters */
	s.setCounters = function(url){
		// Google
		try {
			ga('send', 'pageview', url);
			yaCounter21433141.hit(url);
		} catch (e) {;}
	}

/* Paginator */
	s.initPagePaginator = function(context){
		$('.paginator', (context || this.dom.main)).each(this.initPagePaginatorHandler);
	};

	s.initPagePaginatorHandler = function(i, elem){
		var el = $(elem);
			data = el.attr('data-pager'),
			url = el.attr('data-url');
		if ( ! data || ! url) return;
		try {
			data = JSON.parse(data);
		} catch (e) { return; }
		el.paginator3000({
			pagesTotal   : data.total || 1,
			pagesSpan    : data.visible || 10,
			pageCurrent  : data.current || 1,
			baseUrl      : url || '#'
		});
	};


s.initMenuAnimation = function(){
	$('#nav .nav-item').on('mouseenter', function(){
		var line=$('i',this);
		line.stop();
		line.animate({'width':'100%','opacity':1},300);
	}).on('mouseleave', function(){
		var line=$('i',this);
		line.stop();
		line.animate({'width':'50%','opacity':0},300);
	})
};

s.initFooterAnimation = function(){
	$('.footer-pane .btn-view').on('click', function(){
		var _this = $(this).parent();
		if (_this.hasClass('active')){
			_this.stop().animate({'bottom': -270}, 600);
			_this.removeClass('active');
		} else {
			_this.stop().animate({'bottom': -0}, 600);
			_this.addClass('active');
		}
		return false;
	});

	$('.over-fish').on('mouseenter', function(){
		var _this = $(this);
		_this.find('span').stop();
		_this.find('.cloud-01').fadeTo(300,1, function(){
			_this.find('.cloud-02').fadeTo(300,1, function(){
				_this.find('.cloud-03').fadeTo(300,1, function(){
					_this.find('.balloon').fadeTo(600,1);
				});
			});
		});
	}).on('mouseleave', function(){
		var _this=$(this);
		_this.find('span').add(_this.find('.balloon')).stop();
				_this.find('.cloud-01').stop().fadeTo(300,0);
				_this.find('.cloud-03').fadeTo(300,0, function(){
					_this.find('.cloud-02').fadeTo(300,0, function(){
						_this.find('.cloud-01').fadeTo(300,0);
					});
				});
				_this.find('.cloud-02').stop().fadeTo(300,0, function(){
					_this.find('.cloud-01').fadeTo(300,0);
				});
					_this.find('.balloon').fadeTo(300,0);
	});
};

s.initPageAnimation = function(){
	$('.info-section .block .faq-list li,.info-section .block .info-list li,.request-section .holder>div').on('mouseenter', function(){
		var line=$('.btn-more i',this),
		text=$('.btn-more .text',this),
		arrow=$('.arrow em',this);
		arrow.eq(0).add(arrow.eq(1)).add(text).add(line).stop()
		arrow.eq(0).animate({'left':0,'opacity':1},300)
		arrow.eq(1).animate({'left':'12px','opacity':0},300)
		text.fadeTo(300,1)
		line.animate({'width':'100%','opacity':1},300)
	}).on('mouseleave', function(){
		var line=$('.btn-more i',this),
		text=$('.btn-more .text',this),
		arrow=$('.arrow em',this);
		arrow.eq(0).add(arrow.eq(1)).add(text).add(line).stop()
		arrow.eq(0).animate({'left':'-12px','opacity':0},300)
		arrow.eq(1).animate({'left':0,'opacity':1},300)
		text.fadeTo(300,0)
		line.animate({'width':'80%','opacity':0},300)
	})
};

s.initInfoSection = function(){
	$('.info-section .block').galleryScroll();
	$('.info-section .prev,.info-section .next').on('mouseenter', function(){
		$('span',this).css('opacity',0);
		$('span',this).stop()
		$('span',this).fadeTo(300,1)
	}).on('mouseleave', function(){
		$('span',this).stop()
		$('span',this).fadeTo(300,0)
	});
};

s.initMainTopGallery = function(){
	var gall=$('.gallery'),
		height={end:{top: '175px',bottom: '641px'},start:{top: '20px',bottom: '465px'}},
		duration=500,
		delay=2000,
		use_visual = false;

	gall.find('li:first').addClass('active');

	$('.btn-next',gall).on('click', function(){
		var item=$(this).parents('li'),
			top_shutter=$('.top-shutter',item),
			bottom_shutter=$('.bottom-shutter',item),
			visual=$('.visual',item),
			nextItem=item.next();
			if(nextItem.length===0) nextItem=item.parent().find('li:first')
			var nextTop_shutter=$('.top-shutter',nextItem),
				nextBottom_shutter=$('.bottom-shutter',nextItem);
				nextTop_shutter.css('height',height.end.top);
				nextBottom_shutter.css('height',height.end.bottom);
			top_shutter.animate({'height':height.end.top},duration)
			bottom_shutter.animate({'height':height.end.bottom},duration,function(){
				gall.addClass('shuttered');
				if (use_visual) {
					visual.animate({'top': '-48px'}, duration, function () {
						visual.delay(delay).animate({'top': height.end.top}, duration, function () {
							item.removeClass('active');
							nextItem.addClass('active');
							gall.removeClass('shuttered');
							nextTop_shutter.animate({'height': height.start.top}, duration);
							nextBottom_shutter.animate({'height': height.start.bottom}, duration);
						})
					})
				} else {
					item.removeClass('active');
					nextItem.addClass('active');
					gall.removeClass('shuttered');
					nextTop_shutter.animate({'height': height.start.top}, duration);
					nextBottom_shutter.animate({'height': height.start.bottom}, duration);
				}
			})
			return false;
	})
	$('.btn-prev',gall).on('click', function(){
		var item=$(this).parents('li'),
			top_shutter=$('.top-shutter',item),
			bottom_shutter=$('.bottom-shutter',item),
			visual=$('.visual',item),
			nextItem=item.prev();
			if(nextItem.length===0) nextItem=item.parent().find('li:last')
			var nextTop_shutter=$('.top-shutter',nextItem),
				nextBottom_shutter=$('.bottom-shutter',nextItem);
				nextTop_shutter.css('height',height.end.top);
				nextBottom_shutter.css('height',height.end.bottom);
			top_shutter.animate({'height':height.end.top},duration)
			bottom_shutter.animate({'height':height.end.bottom},duration,function(){
				gall.addClass('shuttered');
				if (use_visual) {
					visual.animate({'top': '-48px'}, duration, function () {
						visual.delay(delay).animate({'top': height.end.top}, duration, function () {
							item.removeClass('active')
							nextItem.addClass('active');
							gall.removeClass('shuttered')
							nextTop_shutter.animate({'height': height.start.top}, duration)
							nextBottom_shutter.animate({'height': height.start.bottom}, duration)
						})
					})
				} else {
					item.removeClass('active')
					nextItem.addClass('active');
					gall.removeClass('shuttered')
					nextTop_shutter.animate({'height': height.start.top}, duration)
					nextBottom_shutter.animate({'height': height.start.bottom}, duration)
				}
			})
			return false;
	})
};

s.initFileInput = function(context){
	$('.js-file-input', context || this.dom.body)
	.on('change', function(e){
		var input = $(e.currentTarget),
			file_list = input.closest('.holder').siblings('.file-list-holder');

		file_list.find('.js-file-name').text(input.val());

		if (file_list.is(':hidden'))
		{
			file_list.show();
		}
	});

	$('.js-file-delete', context || this.dom.body)
	.on('click', function(e){
		var button = $(e.currentTarget),
			file_field = button.closest('.file-list-holder').siblings('.js-file-upload:first');

		file_field.find('.js-file-input').val('');
		button.closest('.file-list-holder').hide();
	});
};

s.initClientGallery = function(){
	var _brend_list = $('.brend-list li');

	_brend_list.parent().width(_brend_list.length*_brend_list.width());
	$('.scroll-box').jScrollPane({
		showArrows: false
	});

	_brend_list.on('mouseenter', function(){
		$(this).find('.substrate').stop().animate({'opacity': 0.8}, 200);
		$(this).find('.text').stop().animate({'opacity': 1}, 200);
	});
	_brend_list.on('mouseleave', function(){
		$(this).find('.substrate').stop().animate({'opacity': 0}, 200);
		$(this).find('.text').stop().animate({'opacity': 0}, 200);
	});

	$('.scroll-box .jspDrag').live('mouseenter',function(){
		var left=$('.jspDragLeft',this),
			right=$('.jspDragRight',this);
			$(this).add(left).add(right).stop()
		left.animate({"left":"-5px","width":"5px",'height':20},300);
		right.animate({"right":"-5px","width":"5px",'height':20},300);
		$(this).animate({'height':20,'top':'-5px'},300)
	}).live('mouseleave',function(){
		var left=$('.jspDragLeft',this),
			right=$('.jspDragRight',this);
			$(this).add(left).add(right).stop()
		left.animate({"left":"0","width":"0",'height':7},300);
		right.animate({"right":"0","width":"0",'height':7},300);
		$(this).animate({'height':7,'top':'-1px'},300)
	});
};

s.initQuestionList = function(){
	$('.question-list li>h4>a').on('click', function(e){
		if(!$(this).parents('ul').find('li .box').is(':animated')){
			if($(this).parents('ul').find('li:has(.box:visible)').index()!=$(this).closest('li').index()){
				$(this).parents('ul').find('li .box:visible').slideToggle(800);
				$(this).closest('li').find('>.box').slideToggle(800);
			}else{
				$(this).closest('li').find('>.box').slideToggle(800);
			}
		}
		e.preventDefault();
	});

	s.scrollToElement('.question-list .enabled');
	setTimeout(function(){
		$('.question-list .enabled>h4>a').triggerHandler('click');
	}, 800);
};

s.initPagePopup = function()
{
	$('.js-page-popup', this.dom.main).on('click.popup', s.pagePopupHandler);
};
s.initSubMenuPopup = function()
{
	$('.js-submenu-popup', s.dom.body).on('click.popup', s.pagePopupHandler);
};
s.initPageRequestPopup = function()
{
	$('.js-request-page-popup', s.dom.body).on('click.popup', s.pagePopupHandler);
};
s.initFooterPopup = function()
{
	$('.js-open-popup', s.dom.body).on('click.popup', s.pagePopupHandler);
};

s.pagePopupHandler = function(event)
{
	event.preventDefault();
	event.stopPropagation();

	var el = $(event.currentTarget);
	s.loadPopup(el.attr("data-popup-name"), el.attr("data-popup-url"), s.showPagePopup, [el]);

	return false;
}

s.showPagePopup = function($popup, el)
{
	s.openPopup($popup);
	$('form', $popup).attr('action', el.attr('href'));
}





s.initPageCatalog = function(){
	$('.catalog li', s.dom.main).on('mouseenter', function(){
		var _this=$(this);
		_this.find('.mask').stop().animate({opacity: 0.6},{queue: false, duration: 200});
		_this.find('.text').stop().animate({opacity: 1},{queue: false, duration: 200});
		_this.find('.box').stop().animate({opacity: 1},{queue: false, duration: 200});
	}).on('mouseleave', function(){
		var _this=$(this);
		_this.find('.mask').stop().animate({opacity: 0},{queue: false, duration: 200});
		_this.find('.text').stop().animate({opacity: 0},{queue: false, duration: 200});
		_this.find('.box').stop().animate({opacity: 0},{queue: false, duration: 200});
	});
};

s.initGalleryHolder = function(){
	$('.gallery-holder', s.dom.body).fade();
};




s.setPageDesign = function(){
	var innerHolder = $('.inner-holder', this.dom.main);

	if (innerHolder.length)
	{
		if ( innerHolder.attr('data-body-class') && ! this.dom.body.hasClass( innerHolder.attr('data-body-class') ))
		{
			console.log('body class changed');
			this.dom.body.removeClass().addClass(innerHolder.attr('data-body-class'));
		}

		var frill = $('.frill', this.dom.header);
		if ( innerHolder.attr('data-show-frill') && frill.is(':hidden') )
		{
			frill.show();
		}
		else if ( ! innerHolder.attr('data-show-frill') && ! frill.is(':hidden') )
		{
			frill.hide();
		}
	}

};





/* initialization */

s.init = function(){
	var path = s.getLocation()['pathname'];

	this.setupPaths();
	this.cacheElements();

/*
 * 		a.not-ajax-link or a has attr _target="_blank"	=>	std action (not ajax)
 * 		a.data-ajax-handler = handler for ajax action
 *
 *		for handler:
 *			s.mainOptions.scrollSelector !== null	=>	after action page scroll to s.scrollSelector
 *
 * */
	if (this.supportsHistoryAPI)
	{
		this.initAjax();
	}
	this.initPopups();


	this.initPage();

	this.initInputs();
	this.initMenuAnimation();
	this.initFooterAnimation();

	s.dom.main.on('ajax.loaded', function(){
		s.scrollToElement( '.header-holder' );
	});
};


/* ajax page init */
s.initPage = function(){
	// Clear dom page
	for (var i in this.domPage)
	{
		if (this.domPage.hasOwnProperty(i))
		{
			this.domPage[i].off();
		}
	}
	this.domPage = {};

	var loc = s.getLocation(),
		url = loc.pathname+loc.search+loc.hash;
	this.setCounters(url);
	this.setMenu(url);

	this.initPageCaptcha();
	this.initPageAjaxForm();
	this.initPageAnimation();

	for (var i = 0; i < this.initList.length; i++)
	{
		try {
			if (this[this.initList[i]])
			{
				this[this.initList[i]]();
			}
			else if (typeof this.initList[i] === 'function')
			{
				this.initList[i]();
			}
		} catch (e) {;}
	}
	this.initList = [];

	s.setPageDesign();

	this.initHashAction();
};


s.initPictureList = function() {
	$('.picture-list li', s.dom.main).on('mouseenter', function(){
		if(!$('.picture-list li').is(':animated')){
			if($(this).hasClass('left01')){
				$('.picture-list li.left02').css({
					'z-index': '3'
				})
			$(this).parent().find('.left03').animate({'margin-left': -383},{queue: false, duration: 300});
				$(this).parent().find('.left02').animate({'margin-left': -139},{queue: false, duration: 300});
				$(this).parent().find('.left03').animate({'margin-left': -51},{queue: false, duration: 300});
			}
			if($(this).hasClass('left02')){
				$('.picture-list li.left01').css({
				'z-index': '1'
			})
			$(this).parent().find('.left02').animate({'margin-left': -471},{queue: false, duration: 300});
			$(this).parent().find('.left03').animate({'margin-left': -383},{queue: false, duration: 300});
				$(this).parent().find('.left03').animate({'margin-left': -51},{queue: false, duration: 300, complete: function(){
					$('.picture-list li.left02').css({
						'z-index': '4'
					})
				}});
			}
			if($(this).hasClass('left03')){
				$('.picture-list li.left02').css({
					'z-index': '3'
				})
			$(this).parent().find('.left02').animate({'margin-left': -471},{queue: false, duration: 300});
			$(this).parent().find('.left03').animate({'margin-left': -383},{queue: false, duration: 300});
			}
			if($(this).hasClass('right03')){
				$(this).animate({'margin-left': -74},{queue: false, duration: 300});
				$(this).parent().find('.left03').animate({'margin-left': -714},{queue: false, duration: 300});
				$('.picture-list li.left02').css({
					'z-index': '2'
				})
			}
			if($(this).hasClass('right02')){
				$(this).animate({'margin-left': 13},{queue: false, duration: 300});
				$(this).parent().find('.left03').animate({'margin-left': -714},{queue: false, duration: 300});
				$(this).parent().find('.right03').animate({'margin-left': -405},{queue: false, duration: 300});
				$('.picture-list li.right03').css({
					'z-index': '3'
				})
			}
			if($(this).hasClass('right01')){
				$(this).parent().find('.right02').animate({'margin-left': -318},{queue: false, duration: 300});
				$(this).parent().find('.right03').animate({'margin-left': -405},{queue: false, duration: 300});
				$(this).parent().find('.left03').animate({'margin-left': -714},{queue: false, duration: 300});
				$('.picture-list li.right03').css({
					'z-index': '3'
				})
			}
		}
	});
	$('.picture-list', s.dom.main).on('mouseleave', function(){
		$('.picture-list li.left01').animate({'margin-left': -560, 'z-index': 1},{queue: false, duration: 300});
		$('.picture-list li.left02').animate({'margin-left': -471, 'z-index': 3},{queue: false, duration: 300});
		$('.picture-list li.left03').animate({'margin-left': -383, 'z-index': 4},{queue: false, duration: 300});
		$('.picture-list li.right03').animate({'margin-left': -74, 'z-index': 2},{queue: false, duration: 300});
		$('.picture-list li.right02').animate({'margin-left': 13, 'z-index': 1},{queue: false, duration: 300});
		$('.picture-list li.right01').animate({'margin-left': 101, 'z-index': 0},{queue: false, duration: 300});
	})
}
















































$(function(){
	window.s.init();
});

jQuery.fn.galleryScroll = function(_options){
	// defaults options
	var _options = jQuery.extend({
		btPrev: 'a.prev',
		btNext: 'a.next',
		holderList: '.faq-list,.info-list',
		scrollElParent: 'ul',
		scrollEl: 'li',
		slideNum: false,
		duration : 1000,
		step: 1,
		circleSlide: false,
		disableClass: 'disable',
		funcOnclick: null,
		autoSlide:false,
		innerMargin:0,
		stepWidth:false
	},_options);

	return this.each(function(){
		var _this = jQuery(this);

		var _holderBlock = jQuery(_options.holderList,_this);
		var _gWidth = _holderBlock.width();
		var _animatedBlock = jQuery(_options.scrollElParent,_holderBlock);
		var _liWidth = jQuery(_options.scrollEl,_animatedBlock).outerWidth(true);
		var _liSum = jQuery(_options.scrollEl,_animatedBlock).length * _liWidth;
		var _margin = -_options.innerMargin;
		var f = 0;
		var _step = 0;
		var _autoSlide = _options.autoSlide;
		var _timerSlide = null;

		if (!_options.step) _step = _gWidth; else _step = _options.step*_liWidth;
		if (_options.stepWidth) _step = _options.stepWidth;

		if (!_options.circleSlide) {
			if (_options.innerMargin == _margin)
				jQuery(_options.btPrev,_this).addClass('prev-'+_options.disableClass);
		}
		if (_options.slideNum && !_options.step) {
			var _lastSection = 0;
			var _sectionWidth = 0;
			while(_sectionWidth < _liSum)
			{
				_sectionWidth = _sectionWidth + _gWidth;
				if(_sectionWidth > _liSum) {
				       _lastSection = _sectionWidth - _liSum;
				}
			}
		}
		if (_autoSlide) {
				_timerSlide = setTimeout(function(){
					autoSlide(_autoSlide);
				}, _autoSlide);
			_animatedBlock.hover(function(){
				clearTimeout(_timerSlide);
			}, function(){
				_timerSlide = setTimeout(function(){
					autoSlide(_autoSlide)
				}, _autoSlide);
			});
		}

		// click button 'Next'
		jQuery(_options.btNext,_this).on('click',function(){
			jQuery(_options.btPrev,_this).removeClass('prev-'+_options.disableClass);
			if (!_options.circleSlide) {
				if (_margin + _step  > _liSum - _gWidth - _options.innerMargin) {
					if (_margin != _liSum - _gWidth - _options.innerMargin) {
						_margin = _liSum - _gWidth  + _options.innerMargin;
						jQuery(_options.btNext,_this).addClass('next-'+_options.disableClass);
						_f2 = 0;
					}
				} else {
					_margin = _margin + _step;
					if (_margin == _liSum - _gWidth - _options.innerMargin) {
						jQuery(_options.btNext,_this).addClass('next-'+_options.disableClass);_f2 = 0;
					}
				}
			} else {
				if (_margin + _step  > _liSum - _gWidth + _options.innerMargin) {
					if (_margin != _liSum - _gWidth + _options.innerMargin) {
						_margin = _liSum - _gWidth  + _options.innerMargin;
					} else {
						_f2 = 1;
						_margin = -_options.innerMargin;
					}
				} else {
					_margin = _margin + _step;
					_f2 = 0;
				}
			}

			_animatedBlock.animate({marginLeft: -_margin+"px"}, {queue:false,duration: _options.duration });

			if (_timerSlide) {
				clearTimeout(_timerSlide);
				_timerSlide = setTimeout(function(){
					autoSlide(_options.autoSlide)
				}, _options.autoSlide);
			}

			if (_options.slideNum && !_options.step) jQuery.fn.galleryScroll.numListActive(_margin,jQuery(_options.slideNum, _this),_gWidth,_lastSection);
			if (typeof _options.funcOnclick === 'function') {
				_options.funcOnclick.apply(_this);
			}
			return false;
		});
		// click button 'Prev'
		var _f2 = 1;
		jQuery(_options.btPrev, _this).on('click',function(){
			jQuery(_options.btNext,_this).removeClass('next-'+_options.disableClass);
			if (_margin - _step >= -_step - _options.innerMargin && _margin - _step <= -_options.innerMargin) {
				if (_f2 != 1) {
					_margin = -_options.innerMargin;
					_f2 = 1;
				} else {
					if (_options.circleSlide) {
						_margin = _liSum - _gWidth  + _options.innerMargin;
						f=1;_f2=0;
					} else {
						_margin = -_options.innerMargin
					}
				}
			} else if (_margin - _step < -_step + _options.innerMargin) {
				_margin = _margin - _step;
				f=0;
			}
			else {_margin = _margin - _step;f=0;};

			if (!_options.circleSlide && _margin == _options.innerMargin) {
				jQuery(this).addClass('prev-'+_options.disableClass);
				_f2=0;
			}

			if (!_options.circleSlide && _margin == -_options.innerMargin) jQuery(this).addClass('prev-'+_options.disableClass);
			_animatedBlock.animate({marginLeft: -_margin + "px"}, {queue:false, duration: _options.duration});

			if (_options.slideNum && !_options.step) jQuery.fn.galleryScroll.numListActive(_margin,jQuery(_options.slideNum, _this),_gWidth,_lastSection);

			if (_timerSlide) {
				clearTimeout(_timerSlide);
				_timerSlide = setTimeout(function(){
					autoSlide(_options.autoSlide)
				}, _options.autoSlide);
			}

			if (typeof _options.funcOnclick === 'function') {
				_options.funcOnclick.apply(_this);
			}
			return false;
		});

		if (_liSum <= _gWidth) {
			jQuery(_options.btPrev,_this).addClass('prev-'+_options.disableClass).off('click');
			jQuery(_options.btNext,_this).addClass('next-'+_options.disableClass).off('click');
		}
		// auto slide
		function autoSlide(autoSlideDuration){
			//if (_options.circleSlide) {
				jQuery(_options.btNext,_this).trigger('click');
			//}
		};
		// Number list
		jQuery.fn.galleryScroll.numListCreate = function(_elNumList, _liSumWidth, _width, _section){
			var _numListElC = '';
			var _num = 1;
			var _difference = _liSumWidth + _section;
			while(_difference > 0)
			{
				_numListElC += '<li><a href="">'+_num+'</a></li>';
				_num++;
				_difference = _difference - _width;
			}
			jQuery(_elNumList).html('<ul>'+_numListElC+'</ul>');
		};
		jQuery.fn.galleryScroll.numListActive = function(_marginEl, _slideNum, _width, _section){

			if (_slideNum) {
				jQuery('a',_slideNum).closest('li').removeClass('active');
				var _activeRange = _width - _section-1;
				var _n =0;
				if (_marginEl != 0) {
					while (_marginEl > _activeRange) {
						_activeRange = (_n * _width) -_section-1 + _options.innerMargin;
						_n++;
					}
				}
				var _a  = (_activeRange+_section+1 + _options.innerMargin)/_width - 1;
				jQuery('a',_slideNum).eq(_a).closest('li').addClass('active');

			}
		};
		if (_options.slideNum && !_options.step) {
			jQuery.fn.galleryScroll.numListCreate(jQuery(_options.slideNum, _this), _liSum, _gWidth,_lastSection);
			jQuery.fn.galleryScroll.numListActive(_margin, jQuery(_options.slideNum, _this),_gWidth,_lastSection);
			numClick();
		};

		function numClick() {
			var values =[0,20,35,49,65,82,100];
			jQuery(_options.slideNum, _this).find('a').on('click', function(){
				if($('#slider').length){
					$('#slider').slider('option','value',values[$(this).parent().index()]);
				}
				jQuery(_options.btPrev,_this).removeClass('prev-'+_options.disableClass);
				jQuery(_options.btNext,_this).removeClass('next-'+_options.disableClass);
				var _indexNum =$(this).parent().index();
				_margin = (_step*_indexNum) - _options.innerMargin;
				f=0; _f2=0;
				if (_indexNum == 0) _f2=1;
				if (_margin + _step > _liSum) {
					_margin = _margin - (_margin - _liSum) - _step + _options.innerMargin;
					if (!_options.circleSlide) jQuery(_options.btNext, _this).addClass('next-'+_options.disableClass);
				}
				_animatedBlock.animate({marginLeft: -_margin + "px"}, {queue:false, duration: _options.duration});

				if (!_options.circleSlide && _margin==0) jQuery(_options.btPrev,_this).addClass('prev-'+_options.disableClass);
				jQuery.fn.galleryScroll.numListActive(_margin, jQuery(_options.slideNum, _this),_gWidth,_lastSection);

				if (_timerSlide) {
					clearTimeout(_timerSlide);
					_timerSlide = setTimeout(function(){
						autoSlide(_options.autoSlide)
					}, _options.autoSlide);
				}
				return false;
			});
				if ($('#slider').length) {
					 var trueValues ={'0':0,'20':1,'35':2,'49':3,'65':4,'82':5,'100':6};
					$( "#slider" ).slider({
						min:0,
						max:100,
						value:0,
						slide:function(event,ui){
							var includeLeft = event.keyCode != $.ui.keyCode.RIGHT;
							var includeRight = event.keyCode != $.ui.keyCode.LEFT;
							var value = findNearest(includeLeft, includeLeft, ui.value);
							$(_options.slideNum, _this).find('ul>li').eq(trueValues[value]).find('a').trigger('click');
							$(this).slider('value', value);
							return false;
						}
					});
					function findNearest(includeLeft, includeRight, value) {
						var nearest = null;
						var diff = null;
						for (var i = 0; i < values.length; i++) {
							if ((includeLeft && values[i] <= value)) {
								var newDiff = Math.abs(value - values[i]);
								if (diff == null || newDiff < diff) {
									nearest = values[i];
									diff = newDiff;
								}
							}
						}
						return nearest;
					}
					$('#slider').slider('option','value',values[jQuery(_options.slideNum, _this).find('.current-day').index()])
				}
				jQuery(_options.slideNum, _this).find('.current-day a').trigger('click');
		};
		jQuery(window).resize(function(){
			_gWidth = _holderBlock.width();
			_liWidth = jQuery(_options.scrollEl,_animatedBlock).outerWidth(true);
			_liSum = jQuery(_options.scrollEl,_animatedBlock).length * _liWidth;
			if (!_options.step) _step = _gWidth; else _step = _options.step*_liWidth;
			if (_options.slideNum && !_options.step) {
				var _lastSection = 0;
				var _sectionWidth = 0;
				while(_sectionWidth < _liSum)
				{
					_sectionWidth = _sectionWidth + _gWidth;
					if(_sectionWidth > _liSum) {
					       _lastSection = _sectionWidth - _liSum;
					}
				};
				jQuery.fn.galleryScroll.numListCreate(jQuery(_options.slideNum, _this), _liSum, _gWidth,_lastSection);
				jQuery.fn.galleryScroll.numListActive(_margin, jQuery(_options.slideNum, _this),_gWidth,_lastSection);
				numClick();
			};
			//if (_margin == _options.innerMargin) jQuery(this).addClass(_options.disableClass);
			if (_liSum - _gWidth  < _margin - _options.innerMargin) {
				if (!_options.circleSlide) jQuery(_options.btNext, _this).addClass('next-'+_options.disableClass);

				_animatedBlock.animate({marginLeft: -(_liSum - _gWidth + _options.innerMargin)}, {queue:false, duration: _options.duration});
			};
		});
	});
}
jQuery.fn.fade= function(o){
	var o= jQuery.extend({
		slides:'li',
		pager:'.gallery-nav',
		pagerItem:'li',
		b_prev:'a.prev',
		b_next:'a.next',
		a_class:'active',
		holder:'.gallery',
		time:500,
		startFrom:0,
		queue:false,
		autoSlide:true,
		autoSlideTime:3000,
		pauseOnHover:false,
		sliderClass:'.slider',
		useSlider:false
	},o);

	return this.each(function(){
		var _this = $(this),
			timerId=0,
			hover=false,
			maxSize=$(o.slides).length,
			a_classEl="."+o.a_class,
			slides=$(o.slides,o.holder),
			pager=$(o.pager,_this),
			pagerItems=$(o.pagerItem,pager),
			slidesHolder=$(o.holder,_this);
			if(o.useSlider){
				var sliderStop=false,
					sliderStart=false,
					slider=$(o.sliderClass,_this).slider({
						max:slides.length-1,
						min:0,
						start:function(e,ui){
							sliderStart=ui.value;
						},
						stop:function(e,ui){
							sliderStop=ui.value;
							if(sliderStart==sliderStop) return false;
							(sliderStart>sliderStop) ? prev():next();
						}
					});
			}

			slides.hide().eq(o.startFrom).addClass(o.a_class).show();
			(!pagerItems.eq(o.startFrom).is(a_classEl)) ? pagerItems.eq(o.startFrom).addClass(o.a_class):false;

			$(o.b_next,_this).on('click',function(){
					next();
					return false;
			});
			$(o.b_prev,_this).on('click',function(){
					prev();
					return false;
			});
			if(pagerItems.length!=0){
				pagerItems.on('click',function(){
				if($(this).is(a_classEl) || slides.is(':animated')) return false;
				var index=$(this).index();
					currPagerLink=$(a_classEl,pager);
						var currSlide=slides.filter(a_classEl),
						nextSlide=slides.eq(index);
					currPagerLink.removeClass(o.a_class);
					$(this).addClass(o.a_class);
				if(!o.queue){
						currSlide.fadeOut(o.time).removeClass(o.a_class);
						nextSlide.fadeIn(o.time).addClass(o.a_class);
					}else{
						currSlide.fadeOut(o.time,function(){
							$(this).removeClass(o.a_class);
							nextSlide.fadeIn(o.time2).addClass(o.a_class);
						})

					}
					if(o.autoSlide && !hover){
						if(timerId) clearRequestTimeout(timerId);
						autoSlide();
					}
				return false;
			})
			}

			if(o.pauseOnHover){
				_this.on('mouseleave',function(){
					hover=false;
					if(timerId) clearRequestTimeout(timerId)
					autoSlide()
				}).on('mouseenter',function(){
					hover=true;
					if(timerId) clearRequestTimeout(timerId)
				})
			}

			function next(){
				if(slides.is(':animated') && !o.useSlider) return false;
				var currSlide=slides.filter(a_classEl),
					nextSlide=getNextEl(currSlide,o.slides,slidesHolder,'next',slides),
					currPagerLink=$(a_classEl,pager),
					nextPagerLink=getNextEl(currPagerLink,o.pagerItem,pager,'next',pagerItems);
					currPagerLink.removeClass(o.a_class);
					nextPagerLink.addClass(o.a_class);
					if(o.useSlider){
						if(sliderStop!==false){
							nextSlide=slides.eq(sliderStop);
							sliderStop=false;
						}else{
							slider.slider('option','value',nextSlide.index())
						}
					}

					if(!o.queue){
						currSlide.fadeOut(o.time).removeClass(o.a_class);
						nextSlide.fadeIn(o.time).addClass(o.a_class);
					}else{
						currSlide.fadeOut(o.time,function(){
							$(this).removeClass(o.a_class);
							nextSlide.fadeIn(o.time2).addClass(o.a_class);
						})

					}
					if(o.autoSlide && !hover){
						if(timerId) clearRequestTimeout(timerId);
						autoSlide();
					}
			}
			function prev(){
				if(slides.is(':animated') && !o.useSlider) return false;
				var currSlide=slides.filter(a_classEl),
					nextSlide=getNextEl(currSlide,o.slides,slidesHolder,'prev',slides),
					currPagerLink=$(a_classEl,pager),
					nextPagerLink=getNextEl(currPagerLink,o.pagerItem,pager,'prev',pagerItems);
					currPagerLink.removeClass(o.a_class);
					nextPagerLink.addClass(o.a_class);
					if(o.useSlider){
						if(sliderStop!==false){
							nextSlide=slides.eq(sliderStop);
							sliderStop=false;
						}else{
							slider.slider('option','value',nextSlide.index())
						}
					}
					if(!o.queue){
						currSlide.fadeOut(o.time).removeClass(o.a_class);
						nextSlide.fadeIn(o.time).addClass(o.a_class);
					}else{
						currSlide.fadeOut(o.time,function(){
							$(this).removeClass(o.a_class);
							nextSlide.fadeIn(o.time).addClass(o.a_class);
						})
					}
			}
			if(o.autoSlide) autoSlide()
			function autoSlide(){
				if(!o.autoSlide) return false;
				timerId=requestTimeout(next,o.autoSlideTime);
			}
			function getNextEl(currEl,elClass,holder,direction,collection){
				if(direction=='next'){
					return (currEl.next().length==0 || !currEl.next().is(elClass)) ? collection.filter(elClass+":first"):currEl.next();
				}else{
					return (currEl.prev().length==0 || !currEl.prev().is(elClass)) ? collection.filter(elClass+":last"):currEl.prev();
				}
			}
	});
}
/*
 * Drop in replace functions for setTimeout() & setInterval() that
 * make use of requestAnimationFrame() for performance where available
 * http://www.joelambert.co.uk
 *
 * Copyright 2011, Joe Lambert.
 * Free to use under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 */
// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
window.requestAnimFrame = (function() {
	return  window.requestAnimationFrame   ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame    ||
			window.oRequestAnimationFrame      ||
			window.msRequestAnimationFrame     ||
			function(/* function */ callback, /* DOMElement */ element){
				window.setTimeout(callback, 1000 / 60);
			};
})();
/**
 * Behaves the same as setTimeout except uses requestAnimationFrame() where possible for better performance
 * @param {function} fn The callback function
 * @param {int} delay The delay in milliseconds
 */
window.requestTimeout = function(fn, delay) {
	if( !window.requestAnimationFrame      	&&
		!window.webkitRequestAnimationFrame &&
		!window.mozRequestAnimationFrame    &&
		!window.oRequestAnimationFrame      &&
		!window.msRequestAnimationFrame)
			return window.setTimeout(fn, delay);

	var start = new Date().getTime(),
		handle = new Object();

	function loop(){
		var current = new Date().getTime(),
			delta = current - start;

		delta >= delay ? fn.call() : handle.value = requestAnimFrame(loop);
	};

	handle.value = requestAnimFrame(loop);
	return handle;
};
/**
 * Behaves the same as clearInterval except uses cancelRequestAnimationFrame() where possible for better performance
 * @param {int|object} fn The callback function
 */
window.clearRequestTimeout = function(handle) {
    window.cancelAnimationFrame ? window.cancelAnimationFrame(handle.value) :
    window.webkitCancelRequestAnimationFrame ? window.webkitCancelRequestAnimationFrame(handle.value)	:
    window.mozCancelRequestAnimationFrame ? window.mozCancelRequestAnimationFrame(handle.value) :
    window.oCancelRequestAnimationFrame	? window.oCancelRequestAnimationFrame(handle.value) :
    window.msCancelRequestAnimationFrame ? msCancelRequestAnimationFrame(handle.value) :
    clearTimeout(handle);
};
